export const FILE_STATUS = {
  PENDING: "PENDING",
  PROCESSING: "PROCESSING",
  COMPLETED: "COMPLETED",
  FAILED: "FAILED",
  EXPIRED: "EXPIRED",
  IN_PROCESS: "IN_PROCESS",
  PROCESSED: "PROCESSED",
  UPLOADED: "UPLOADED",
};

export const OPERATION_TYPE = {
  EXPORT: "EXPORT",
  IMPORT: "IMPORT",
  ALL: "ALL",
};

export const CONTEXT_TYPE_EXPORTS = [
  { key: "LEADERBOARDS", text: "Export leaderboard", type: "exports" },
  { key: "CONSUMER_REWARDS", text: "Export consumer reward", type: "exports" },
  { key: "CODE_GROUP", text: "Code group", type: "exports" },
  {
    key: "INSTANTWIN_PRIZE_SEED",
    text: "Export instant win moments",
    type: "exports",
  },
  { key: "SWEEPSTAKE_ENTRIES", text: "Export sweepstakes entries", type: "exports" },
  { key: "SWEEPSTAKE_WINNERS", text: "Export sweepstakes winners", type: "exports" },
  {
    key: "SWEEPSTAKE_DRAW_WINNERS",
    text: "Export sweepstakes draw winners",
    type: "exports",
  },
  { key: "USERS_BY_SEGMENT", text: "Export users by segment", type: "exports" },
  { key: "USER_PROFILE", text: "Export users", type: "exports" },
  { key: "FULFILLMENT_ORDER", text: "Export fulfillment orders", type: "exports" },
  { key: "USERS_PERFORMANCES", text: "Export user performances", type: "exports" },
  {
    key: "RECEIPT_SCAN_PERFORMANCES",
    text: "Export receipt scan performances",
    type: "exports",
  },
  { key: "KEYWORD_GROUPS", text: "Export keyword groups", type: "exports" },
];

export const CONTEXT_TYPE_IMPORTS = [
  {
    key: "LEADERBOARDS_MODIFY_REWARD_RANKS",
    text: "Leaderboards modify rank entries",
    type: "imports",
  },
  {
    key: "LEADERBOARDS_REMOVE_USERS",
    text: "Leaderboards remove users",
    type: "imports",
  },
  {
    key: "INSTANT_WIN_IMPORT_PRIZE_SEED_DATA",
    text: "Instant win import moments",
    type: "imports",
  },
  {
    key: "CONSUMER_REWARD_STATUS_UPDATES",
    text: "Consumer reward status updates",
    type: "imports",
  },
  {
    key: "SWEEPSTAKES_MANUAL_WINNER_SELECTION",
    text: "Sweepstakes manual winner selection",
    type: "imports",
  },
  {
    key: "SWEEPSTAKES_DRAW_PRESELECT_ENTRIES",
    text: "Sweepstakes draw preselect entries",
    type: "imports",
  },
  {
    key: "SWEEPSTAKES_INELIGIBLE_PROFILES",
    text: "Sweepstakes ineligible profiles",
    type: "imports",
  },
  { key: "PLATFORM_SEGMENTS", text: "Platform segments", type: "imports" },
  { key: "KEYWORD_GROUPS", text: "Keyword Groups", type: "imports" },
];

export const STATUS_COLORS = {
  PENDING: "#0066CC",
  PROCESSING: "#FFA500",
  COMPLETED: "#28A745",
  FAILED: "#DC3545",
  EXPIRED: "#6C757D",
  IN_PROCESS: "#FFA500",
  PROCESSED: "#28A745",
  UPLOADED: "#0066CC",
};

export const STATUS_LABELS = {
  PENDING: "Pending",
  PROCESSING: "Processing",
  COMPLETED: "Completed",
  FAILED: "Failed",
  EXPIRED: "Expired",
  IN_PROCESS: "In Process",
  PROCESSED: "Processed",
  UPLOADED: "Uploaded",
};

export const POLLING_INTERVAL = 5000;
export const ITEMS_PER_PAGE = 20;
export const MAX_FILENAME_LENGTH = 40;
